// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"o0-z","subtitle":"p0-z","wrapper":"q0-z","leftArrow":"r0-z","rightArrow":"s0-z"};